import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.updateGeneralSetting.loading;
export const selectErrorMessage = (state: RootState) =>
  state.updateGeneralSetting.error;
export const updateGeneralSettingResponse = (state: RootState) =>
  state.updateGeneralSetting.updateGeneralSettingResponse;
